<div *ngIf="reportType == 'VeryBriefly-CreditNote'">
  <div class="container-fluid" id="print-section">
    <table class="table table-bordered"
           style="width: 100%; border-collapse: collapse; font-size: 14px; border: 1.5px solid #666;">
      <thead>
        <tr style="height: 40px;">
          <th colspan="2" style="padding: 8px; text-align: left; font-weight: bold; border: 1.5px solid #666;">Vivek Saptahik</th>
          <th colspan="4" style="padding: 8px; text-align: center; font-weight: bold; border: 1.5px solid #666;">Issue Seller Credit Note Register</th>
          <th colspan="2" style="padding: 8px; text-align: right; font-weight: bold; border: 1.5px solid #666;">
            Date {{ currentDate | date: 'dd-MM-yyyy' }}
          </th>
        </tr>
        <tr style="height: 35px;">
          <th colspan="2" style="padding: 8px; border: 1.5px solid #666;">Office Representative</th>
          <th colspan="4" style="padding: 8px; border: 1.5px solid #666;">Very Briefly Officer</th>
          <th colspan="2" style="padding: 8px; border: 1.5px solid #666;">
            Date From {{ startDate | date: 'dd-MM-yyyy' }} To {{ endDate | date: 'dd-MM-yyyy' }}
          </th>
        </tr>
        <tr style="height: 35px;">
          <th colspan="2" style="padding: 8px; border: 1.5px solid #666;">Representative Name</th>
          <th colspan="2" style="padding: 8px; border: 1.5px solid #666;">Office Representative Name</th>
          <th colspan="2" style="padding: 8px; text-align: center; border: 1.5px solid #666;">Credit Note Amount</th>
          <th colspan="2" style="padding: 8px; text-align: center; border: 1.5px solid #666;">Total</th>
        </tr>
        <tr>
          <th colspan="4" style="border: 1.5px solid #666;"></th>
          <th style="text-align: center; padding: 8px; border: 1.5px solid #666;">अंक परत</th>
          <th style="text-align: center; padding: 8px; border: 1.5px solid #666;">अंक गहाळ/खराब</th>
          <th colspan="2" style="border: 1.5px solid #666;"></th>
        </tr>
      </thead>

      <tbody *ngFor="let data of CreditNoteVBFormBeans; let i = index">
        <!-- Office Representative Heading Row -->
        <tr style="height: 40px;">
          <td colspan="2" style="padding: 8px; font-weight: bold; border: 1.5px solid #666; vertical-align: middle;">Office Representative</td>
          <td colspan="2" style="padding: 8px; font-weight: bold; border: 1.5px solid #666; vertical-align: middle;">{{ data.office_rep }}</td>
          <td colspan="4" style="border: 1.5px solid #666;"></td>
        </tr>

        <!-- Representative Data -->
        <tr *ngFor="let data1 of data.rep_data; let j = index">
          <td colspan="2" style="padding: 8px; border: 1.5px solid #666;">{{ data1.rep_name }}</td>
          <td colspan="2" style="padding: 8px; border: 1.5px solid #666;">{{ data.office_rep }}</td>
          <td style="padding: 8px; text-align: right; border: 1.5px solid #666;">{{ data1.tds_amt }}</td>
          <td style="padding: 8px; text-align: right; border: 1.5px solid #666;">{{ data1.other_credit_amt }}</td>
          <td colspan="2" style="padding: 8px; text-align: right; border: 1.5px solid #666;">{{ data1.credit_amt }}</td>
        </tr>

        <!-- Subtotal for each Office Representative -->
        <tr style="height: 35px;">
          <td colspan="2" style="border: 1.5px solid #666;"></td>
          <td colspan="2" style="padding: 8px; font-weight: bold; text-align: right; border: 1.5px solid #666;">Total</td>
          <td style="padding: 8px; font-weight: bold; text-align: right; border: 1.5px solid #666;">{{ data.tds_amt }}</td>
          <td style="padding: 8px; font-weight: bold; text-align: right; border: 1.5px solid #666;">{{ data.other_credit_amt }}</td>
          <td colspan="2" style="padding: 8px; font-weight: bold; text-align: right; border: 1.5px solid #666;">{{ data.total }}</td>
        </tr>
      </tbody>

     
        <tr style="height: 40px;">
          <td colspan="2" style="padding: 8px; font-weight: bold; text-align: right; border: 1.5px solid #666;">Grand Total:</td>
          <td colspan="3" style="padding: 8px; font-weight: bold; text-align: right; border: 1.5px solid #666;">{{ CreditadvtOffVBMTotalTDS }}</td>
          <td style="padding: 8px; font-weight: bold; text-align: right; border: 1.5px solid #666;">{{ CreditadvtOffVBMTotalOther }}</td>
          <td colspan="2" style="padding: 8px; font-weight: bold; text-align: right; border: 1.5px solid #666;">{{ CreditadvtOffVBMTotal }}</td>
        </tr>
     
    </table>
  </div>

  <!-- Buttons (Hidden in Print) -->
  <div class="noPrint" style="display: flex; justify-content: flex-end; gap: 16px; margin-top: 20px; margin-right: 22%;">
    <button (click)="exportExcel('Contract_InDetails_Report')" mat-raised-button color="primary">ExportOff</button>
    <button mat-raised-button color="primary" [useExistingCss]="true" printSectionId="print-section" ngxPrint>Print</button>
    <button mat-button mat-dialog-close>Close</button>
  </div>
</div>
